import request from '@/utils/request'

/* 首页信息获取 */
export const getHomeInfo = () => {
  return request({
    url: '/home_page/v1'
  })
}

/* 首页第三方统计 */
export const getTriData = (params) => {
  return request({
    url: '/home_page/sale_statistics/v1',
    params
  })
}

/* 获取折线图数据 */
export const getChartData = (params) => {
  return request({
    url: '/home_page/sale_amount/v1',
    params
  })
}

// 首页获取经营数据
export const operateDataApi = () => {
  return request({
    url: '/home_page/business_data/v1'
  })
}
// 首页获取销售额信息
export const salesInfoApi = () => {
  return request({
    url: '/home_page/sale_count/v3'
  })
}

//待办事项
export function getToDoList(params) {
  return request({
    url: '/mct_pending_order/v1',
    params
  })
}

//待办事项-关闭
export function disableToDoList(id) {
  return request({
    url: `/mct_pending_order/close/${ id }/v1`,
    method: 'PUT'
  })
}

/*
* 微信进件
* */

//列表
export function getWechatReceivePaymentApplyList() {
  return request({
    url: '/mct_self_receive_payment_apply/v1'
  })
}

//申请
export function applyWechatReceivePayment(data) {
  return request({
    url: '/mct_self_receive_payment_apply/v1',
    method: 'POST',
    data
  })
}

//编辑
export function editWechatReceivePayment(id, data) {
  return request({
    url: `/mct_self_receive_payment_apply/${ id }/v1`,
    method: 'PUT',
    data
  })
}

//详情
export function getWechatReceivePaymentApplyDetails(id) {
  return request({
    url: `/mct_self_receive_payment_apply/${ id }/v1`
  })
}

//设置选中
export function setWechatReceivePaymentApply(id) {
  return request({
    url: `/mct_self_receive_payment_apply/selected/${ id }/v1`
  })
}

//绑定
export function bindWechatReceivePayment(id) {
  return request({
    url: `/mct_self_receive_payment_apply/bind/${ id }/v1`
  })
}

//查询绑定状态
export function searchWechatBindStatus(id) {
  return request({
    url: `/mct_self_receive_payment_apply/query/bind/${ id }/v1`
  })
}

//更新进件状态
export function updateApplyStatus_wechat(id) {
  return request({
    url: `/mct_self_receive_payment_apply/query/apply/${ id }/v1`
  })
}

/*
* 支付宝进件
* */

//列表
export function getAlipayReceivePaymentApplyList() {
  return request({
    url: '/mct_self_receive_ali_payment_apply/v1'
  })
}

//申请
export function applyAlipayReceivePayment(data) {
  return request({
    url: '/mct_self_receive_ali_payment_apply/v1',
    method: 'POST',
    data
  })
}

//编辑
export function editAlipayReceivePayment(id, data) {
  return request({
    url: `/mct_self_receive_ali_payment_apply/${ id }/v1`,
    method: 'PUT',
    data
  })
}

//详情
export function getAlipayReceivePaymentApplyDetails(id) {
  return request({
    url: `/mct_self_receive_ali_payment_apply/${ id }/v1`
  })
}

//设置选中
export function setAlipayReceivePaymentApply(id) {
  return request({
    url: `/mct_self_receive_ali_payment_apply/selected/${ id }/v1`
  })
}

//更新进件状态
export function updateApplyStatus_alipay(id) {
  return request({
    url: `/mct_self_receive_ali_payment_apply/query/apply/${ id }/v1 `
  })
}